/**
 * TanStack Query hooks for ReportComment resource.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@client/lib/api-client';

export interface ReportComment {
  id: string;
  reportId: string;
  authorId: string;
  authorName?: string | null;
  branchId: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export const reportCommentKeys = {
  all: ['report-comments'] as const,
  list: (reportId: string) => ['report-comments', 'list', reportId] as const,
};

export function useReportComments(reportId: string) {
  return useQuery({
    queryKey: reportCommentKeys.list(reportId),
    queryFn: () =>
      api.getPage<ReportComment>(`/api/progress-reports/${reportId}/comments`),
    enabled: !!reportId,
  });
}

export function useCreateReportComment(reportId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { content: string }) =>
      api.post<ReportComment>(`/api/progress-reports/${reportId}/comments`, data),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: reportCommentKeys.list(reportId) });
    },
  });
}
